var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    {
      class: _vm.ContainerClass + _vm.roundStyle,
      attrs: { elevation: _vm.elevation },
    },
    [_c("v-card-text", { class: _vm.ContentClass }, [_vm._t("default")], 2)],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }